<template>
  <div>
    <!-- 我的加班 -->
    <div class="box-margin">
      <Form :model="formItem" label-position="left" :disabled="prevent" :label-width="100">
        <Row style="margin-bottom: 0">
          <Col span="6">
            <FormItem label="日期">
              <DatePicker style="width: 100%" format="yyyy/MM/dd" type="daterange" v-model="serDate" :editable="false"></DatePicker>
            </FormItem>
          </Col>
          <Col span="6" offset="1">
            <FormItem label="申请单号">
              <Input v-model="formItem.order_no" />
            </FormItem>
          </Col>
          <Col span="7" offset="1">
            <FormItem label="申请单状态">
              <Select v-model="formItem.status" style="width: 100%" clearable>
                <Option v-for="item in statusList" :value="item.code" :key="item.code">{{ item.name1 }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <!-- <Row>
          <Col span="1">
            <Button type="primary" @click="pageInfo1.pageNo = 1,pageInfo1.itemCount = 0,pageInfo3.pageNo = 1,pageInfo3.itemCount = 0,mainSearch1()">明细</Button>
          </Col>
          <Col span="1" offset="1">
            <Button type="primary" @click="pageInfo2.pageNo = 1,pageInfo2.itemCount = 0,mainSearch2()">统计</Button>
          </Col>
        </Row> -->
      </Form>
    </div>
    <div class="box-margin">
      <Card>
        <p slot="title">加班申请单明细信息</p>
        <Table border :columns="columns1" :data="data1" :loading="modal_loading" ref="tableMXDetails">
        </Table>
        <Page style="margin-top: 20px; display: flex; justify-content: flex-end" :total="pageInfo1.itemCount" @on-change="pageChange1"/>
        <Form :disabled="prevent" style="display: flex; justify-content: flex-end; margin-top: 20px">
          <Button type="primary" style="margin-left: 8px" @click="exportExcelMX()">导出</Button>
        </Form>
        <ul style="margin-top: -70px; color: red; list-style-type: none">
          <li>1.当前月加班小时数注记补休且立即使用者，补休已用小时数、补休剩余小时数明细须待次月中人事承办人完成当前月勤惰作业后方可查询。</li>
          <li>2.上月加班小时数注记补休且上月已使用者，补休已用小时数、补休剩余小时数明细须待当前月中人事承办人完成上月勤惰作业后方可查询。</li>
          <li>3.下表“截至今日剩余补休有效小时数”、“当月月底即将过期补休小时数”均为最新数据，敬请参考。</li>
        </ul>
      </Card>
    </div>
    <div class="box-margin">
      <Card>
        <p slot="title">实际加班明细信息</p>
        <Table border :columns="columns5" :data="data5" :loading="modal_loading" ref="tableMXDetails">
        </Table>
        <Page style="margin-top: 20px; display: flex; justify-content: flex-end" :total="pageInfo5.itemCount" @on-change="pageChange5"/>
        <Form :disabled="prevent" style="display: flex; justify-content: flex-end; margin-top: 20px">
          <Button type="primary" style="margin-left: 8px" @click="exportExcelSJMX()">导出</Button>
        </Form>
      </Card>
    </div>
    <div class="box-margin">
      <Card>
        <p slot="title">统计信息</p>
        <Table border :columns="columns4" :data="data4" :loading="modal_loading" ref="tableTJDetails">
        </Table>
        <Page style="margin-top: 20px; display: flex; justify-content: flex-end" :total="pageInfo2.itemCount" @on-change="pageChange2"/>
        <Form :disabled="prevent" style="display: flex; justify-content: flex-end; margin-top: 20px">
          <Button type="primary" style="margin-left: 8px" @click="exportExcelTJ()">导出</Button>
        </Form>
      </Card>
    </div>
  </div>
</template>
<script>
import DateUtil from "../../../util/DateUtil";
import axios from "axios";
export default {
  data() {
    return {
      serDate:null,
      orgsname2List: [],
      orgsname4List: [],
      orgsname5List: [],
      orgsname6List: [],
      orgsname7List: [],
      sybxhours: 0,
      yxbxhours: 0,
      datalist1: [],
      datalist2: [],
      datalist3: [],
      ruleValidate: {
        orgsname2: [{ required: true }],
        orgsname4: [{ required: true }],
      },
      formItem: {
        orgsname2: "",
        orgsname4: "",
      },
      filter: {},
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      statusList: [
        {
          code: "0",
          name1: this.$t("share.applicationInProgress"),
        },
        {
          code: "8",
          name1: this.$t("share.sqtg"),
        },
      ],
      totalNum: 0,
      prevent: false,
      modal_loading: false,
      config: false,
      titleText: this.$t("share.selectPeople"),
      date: new DateUtil(),
      rsztList: [],
      columns1: [
        // {
        //   title: "员工工号",
        //   key: "emp_code",
        //   width: 120,
        //   align: "center",
        //   fixed: "left",
        // },
        // {
        //   title: "姓名",
        //   key: "user_name",
        //   width: 110,
        //   align: "center",
        //   fixed: "left",
        // },
        // {
        //   title: "公司",
        //   key: "orgsname2",
        //   width: 100,
        //   align: "center",
        // },
        // {
        //   title: "地区",
        //   key: "orgsname4",
        //   width: 100,
        //   align: "center",
        // },
        // {
        //   title: "职位",
        //   key: "position_name",
        //   width: 160,
        //   align: "center",
        // },
        {
          title: "加班类别",
          key: "ottype",
          // width: "130",
          align: "center",
        },
        {
          title: "加班日期",
          key: "att_date",
          // width: "160",
          align: "center",
        },
        {
          title: "开始时间",
          key: "begintime",
          // width: "160",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(
                params.row.att_date + " " + params.row.begintime,
                "HH:mm"
              )
            );
          },
        },
        {
          title: "结束时间",
          key: "endtime",
          // width: "160",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(
                params.row.att_date + " " + params.row.endtime,
                "HH:mm"
              )
            );
          },
        },
        {
          title: "加班小时数",
          key: "ottime",
          // width: "130",
          align: "center",
        },
        {
          title: "申请单号",
          key: "order_no",
          // width: "250",
          align: "center",
        },
      ],
      data1: [
        {
          att_date: "1998/06/06",
          begintime: "07:00:00",
          buxiuh: 0,
          clhours: 0,
          clused: 0,
          emp_code: "579444",
          user_name: "馮　義",
          endtime: "17:00:00",
          hrstatus: "L1",
          is_late: "",
          isvalid: "",
          jiabanfeih: 9,
          order_no: "",
          orgsname1: "EVG",
          orgsname2: "UGH",
          orgsname3: "000",
          orgsname4: "000",
          orgsname5: "S61",
          orgsname6: "C51",
          ottime: 9,
          ottype: "H01",
          position_name: "驾驶员",
          rszt: "当地员工(试用/正式)",
          serialnumber: "0000001906",
          status: "8",
          status_nm: "",
          super_sure: ""
        },
        {
          att_date: "1998/06/06",
          begintime: "08:30:00",
          buxiuh: 0,
          clhours: 0,
          clused: 0,
          emp_code: "586110",
          user_name: "陆芳华",
          endtime: "12:00:00",
          hrstatus: "L1",
          is_late: "",
          isvalid: "",
          jiabanfeih: 3.5,
          order_no: "",
          orgsname1: "EVG",
          orgsname2: "UGH",
          orgsname3: "000",
          orgsname4: "000",
          orgsname5: "S61",
          orgsname6: "D11",
          ottime: 3.5,
          ottype: "H01",
          position_name: "课员",
          rszt: "当地员工(试用/正式)",
          serialnumber: "0000001897",
          status: "8",
          status_nm: "",
          super_sure: ""
        },
      ],
      columns4: [
        // {
        //   title: "员工工号",
        //   key: "emp_code",
        //   width: 100,
        //   align: "center",
        //   fixed: "left",
        // },
        // {
        //   title: "姓名",
        //   key: "user_name",
        //   width: 100,
        //   align: "center",
        //   fixed: "left",
        // },
        // {
        //   title: "公司",
        //   key: "orgsname2",
        //   width: 70,
        //   align: "center",
        // },
        // {
        //   title: "地区",
        //   key: "orgsname4",
        //   width: 70,
        //   align: "center",
        // },
        {
          title: "总加班",
          align: "center",
          children: [
            {
              title: "W加班",
              align: "center",
              children: [
                {
                  title: "人次",
                  key: "wCount",
                  align: "center",
                  width: "100",
                },
                {
                  title: "小时数",
                  key: "wothour",
                  align: "center",
                  width: "100",
                },
              ],
            },
            {
              title: "H加班",
              align: "center",
              children: [
                {
                  title: "人次",
                  key: "hCount",
                  align: "center",
                  width: "100",
                },
                {
                  title: "小时数",
                  key: "hothour",
                  align: "center",
                  width: "100",
                },
              ],
            },
            {
              title: "N加班",
              align: "center",
              children: [
                {
                  title: "人次",
                  key: "nCount",
                  align: "center",
                  width: "100",
                },
                {
                  title: "小时数",
                  key: "nothour",
                  align: "center",
                  width: "100",
                },
              ],
            },
            {
              title: "小计",
              align: "center",
              children: [
                {
                  title: "人次",
                  key: "totalCon",
                  align: "center",
                  width: "100",
                },
                {
                  title: "小时数",
                  key: "totalNum",
                  align: "center",
                  width: "100",
                },
              ],
            },
          ],
        },
        {
          title: "补休",
          align: "center",
          children: [
            {
              title: "W加班",
              align: "center",
              children: [
                {
                  title: "小时数",
                  key: "wothour1",
                  align: "center",
                  width: "100",
                },
              ],
            },
            {
              title: "H加班",
              align: "center",
              children: [
                {
                  title: "小时数",
                  key: "hothour1",
                  align: "center",
                  width: "100",
                },
              ],
            },
            {
              title: "N加班",
              align: "center",
              children: [
                {
                  title: "小时数",
                  key: "nothour1",
                  align: "center",
                  width: "100",
                },
              ],
            },
            {
              title: "小计",
              align: "center",
              children: [
                {
                  title: "小时数",
                  key: "buxiuthour",
                  align: "center",
                  width: "100",
                },
              ],
            },
          ],
        },
        {
          title: this.$t("overtimeDetail.qljbf"),
          align: "center",
          children: [
            {
              title: "W加班",
              align: "center",
              children: [
                // {
                //   title: this.$t('baoxianInfo.personTime'),
                //   key: "wCount2",
                //   align: "center",
                //   width: "100",
                // },
                {
                  title: "小时数",
                  key: "wothour2",
                  align: "center",
                  width: "100",
                },
              ],
            },
            {
              title: "H加班",
              align: "center",
              children: [
                // {
                //   title: this.$t('baoxianInfo.personTime'),
                //   key: "hCount2",
                //   align: "center",
                //   width: "100",
                // },
                {
                  title: "小时数",
                  key: "hothour2",
                  align: "center",
                  width: "100",
                },
              ],
            },
            {
              title: "N加班",
              align: "center",
              children: [
                // {
                //   title: this.$t('baoxianInfo.personTime'),
                //   key: "nCount2",
                //   align: "center",
                //   width: "100",
                // },
                {
                  title: "小时数",
                  key: "nothour2",
                  align: "center",
                  width: "100",
                },
              ],
            },
            {
              title: "小计",
              align: "center",
              children: [
                // {
                //   title: this.$t('baoxianInfo.personTime'),
                //   key: "qinglingCount",
                //   align: "center",
                //   width: "100",
                // },
                {
                  title: "小时数",
                  key: "qinglingthour",
                  align: "center",
                  width: "100",
                },
              ],
            },
          ],
        },
      ],
      data4: [
        {
          buxiuCount: 0,
          buxiuthour: 0,
          emp_code: "036481",
          user_name: "马文忠",
          hCount: 0,
          hCount1: 0,
          hCount2: 0,
          hothour: 0,
          hothour1: 0,
          hothour2: 0,
          nCount: 0,
          nCount1: 0,
          nCount2: 0,
          nothour: 0,
          nothour1: 0,
          nothour2: 0,
          orgsname2: "MAC",
          orgsname4: "SHG",
          orgsname5: "MAR",
          orgsname6: "MAR",
          orgsname7: "",
          qinglingCount: 0,
          qinglingthour: 0,
          rszt: "上海驻派员工",
          totalCon: 0,
          totalNum: 0,
          wCount: 0,
          wCount1: 0,
          wCount2: 0,
          wothour: 0,
          wothour1: 0,
          wothour2: 0
        },
        {
          buxiuCount: 0,
          buxiuthour: 0,
          emp_code: "204798",
          user_name: "欧技全",
          hCount: 0,
          hCount1: 0,
          hCount2: 0,
          hothour: 0,
          hothour1: 0,
          hothour2: 0,
          nCount: 0,
          nCount1: 0,
          nCount2: 0,
          nothour: 0,
          nothour1: 0,
          nothour2: 0,
          orgsname2: "MAC",
          orgsname4: "SHG",
          orgsname5: "ENG",
          orgsname6: "",
          orgsname7: "",
          qinglingCount: 0,
          qinglingthour: 0,
          rszt: "上海驻派员工",
          totalCon: 0,
          totalNum: 0,
          wCount: 0,
          wCount1: 0,
          wCount2: 0,
          wothour: 0,
          wothour1: 0,
          wothour2: 0
        },
      ],
      
      columns5: [
        {
          title: "加班类别",
          key: "ottype",
          // width: "130",
          align: "center",
        },
        {
          title: "加班日期",
          key: "att_date",
          // width: "160",
          align: "center",
        },
        {
          title: "开始时间",
          key: "begintime",
          // width: "160",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(
                params.row.att_date + " " + params.row.begintime,
                "HH:mm"
              )
            );
          },
        },
        {
          title: "结束时间",
          key: "endtime",
          // width: "160",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(
                params.row.att_date + " " + params.row.endtime,
                "HH:mm"
              )
            );
          },
        },
        {
          title: "加班小时数",
          key: "ottime",
          // width: "130",
          align: "center",
        },
      ],
      data5: [
        {
          att_date: "1998/06/06",
          begintime: "07:00:00",
          buxiuh: 0,
          clhours: 0,
          clused: 0,
          emp_code: "579444",
          user_name: "馮　義",
          endtime: "17:00:00",
          hrstatus: "L1",
          is_late: "",
          isvalid: "",
          jiabanfeih: 9,
          order_no: "",
          orgsname1: "EVG",
          orgsname2: "UGH",
          orgsname3: "000",
          orgsname4: "000",
          orgsname5: "S61",
          orgsname6: "C51",
          ottime: 9,
          ottype: "H01",
          position_name: "驾驶员",
          rszt: "当地员工(试用/正式)",
          serialnumber: "0000001906",
          status: "8",
          status_nm: "",
          super_sure: ""
        },
        {
          att_date: "1998/06/06",
          begintime: "08:30:00",
          buxiuh: 0,
          clhours: 0,
          clused: 0,
          emp_code: "586110",
          user_name: "陆芳华",
          endtime: "12:00:00",
          hrstatus: "L1",
          is_late: "",
          isvalid: "",
          jiabanfeih: 3.5,
          order_no: "",
          orgsname1: "EVG",
          orgsname2: "UGH",
          orgsname3: "000",
          orgsname4: "000",
          orgsname5: "S61",
          orgsname6: "D11",
          ottime: 3.5,
          ottype: "H01",
          position_name: "课员",
          rszt: "当地员工(试用/正式)",
          serialnumber: "0000001897",
          status: "8",
          status_nm: "",
          super_sure: ""
        },
      ],
      pageInfo1: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      pageInfo2: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      pageInfo3: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      pageInfo5: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      isShow: true,
      isCKorg2: true,
      isRole: false,
      // allDataTrue: [],
      // allData: [],
    };
  },
  watch: {},
  mounted() {},
  methods: {
    pageChange1(){

    },
    pageChange2(){

    },
    pageChange5(){

    },
  },
};
</script>
<style  scoped>
.box-margin {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/MyQuery/MyOverTime.vue